var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/**
 * @fileoverview added by tsickle
 * Generated from: models/time-slot.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { combine, todayNaive, toTime } from '../util/datetime/index';
import { defineModelProperties, model } from '../util/model';
/** @type {?} */
export var ANY_TIME_SLOT_START = toTime('09:00:00');
/** @type {?} */
export var ANY_TIME_SLOT_END = toTime('17:00:00');
/** @enum {string} */
var SlotType = {
    Afternoon: "afternoon",
    AnyTime: "any-time",
    Custom: "custom",
    Morning: "morning",
};
export { SlotType };
/**
 * @record
 */
function FlexibleSlot() { }
if (false) {
    /** @type {?} */
    FlexibleSlot.prototype.type;
    /** @type {?} */
    FlexibleSlot.prototype.label;
    /** @type {?} */
    FlexibleSlot.prototype.start;
    /** @type {?} */
    FlexibleSlot.prototype.end;
}
/** @type {?} */
var FLEXIBLE_SLOTS = [
    {
        type: SlotType.Morning,
        label: 'Morning',
        start: toTime('09:00:00'),
        end: toTime('12:00:00')
    },
    {
        type: SlotType.Afternoon,
        label: 'Afternoon',
        start: toTime('12:00:00'),
        end: toTime('17:00:00')
    },
    {
        type: SlotType.AnyTime,
        label: 'Daytime',
        start: ANY_TIME_SLOT_START,
        end: ANY_TIME_SLOT_END
    }
];
/**
 * Base model for the arrival time slot of a visit.
 * @record
 */
function BaseTimeSlotModel() { }
if (false) {
    /** @type {?} */
    BaseTimeSlotModel.prototype.start;
    /** @type {?} */
    BaseTimeSlotModel.prototype.end;
}
/**
 * Display options for `TimeSlot.startTimeDisplay`.
 * @record
 */
function StartTimeDisplayOpts() { }
if (false) {
    /**
     * If the time slot has the same start and end time, include the word "sharp".
     * @type {?|undefined}
     */
    StartTimeDisplayOpts.prototype.includeSharp;
    /**
     * If the time slot has a label, e.g. "Morning" or "During the day", display that instead of the times.
     * @type {?|undefined}
     */
    StartTimeDisplayOpts.prototype.replaceWithLabel;
    /**
     * If the time slot has a label, prepend it to the time rather than outright replace
     * @type {?|undefined}
     */
    StartTimeDisplayOpts.prototype.prependWithLabel;
}
/**
 * Helper properties and methods for the `TimeSlot` model.
 * @record
 */
function TimeSlotModelMixin() { }
if (false) {
    /**
     * Returns `true` if this slot has the same start and end time as the specified slot
     * @type {?}
     */
    TimeSlotModelMixin.prototype.equals;
    /** @type {?} */
    TimeSlotModelMixin.prototype.equalsTime;
    /** @type {?} */
    TimeSlotModelMixin.prototype.intersects;
    /**
     * `true` if this is an "any time" slot, `false` otherwise.
     * @type {?}
     */
    TimeSlotModelMixin.prototype.isAnyTime;
    /**
     * `true` if this is a flexible slot, `false` if it is a custom slot.
     * @type {?}
     */
    TimeSlotModelMixin.prototype.isFlexible;
    /**
     * `true` if the start and end time are the same, `false` otherwise.
     * @type {?}
     */
    TimeSlotModelMixin.prototype.isInstant;
    /**
     * A human-readable label for the time slot.
     * @type {?}
     */
    TimeSlotModelMixin.prototype.label;
    /**
     * Returns a string describing the time slot, for display purposes.
     * @type {?}
     */
    TimeSlotModelMixin.prototype.startTimeDisplay;
    /**
     * The type of time slot.
     * @type {?}
     */
    TimeSlotModelMixin.prototype.type;
    /** @type {?} */
    TimeSlotModelMixin.prototype.day;
    /** @type {?} */
    TimeSlotModelMixin.prototype.startDt;
    /** @type {?} */
    TimeSlotModelMixin.prototype.endDt;
}
/**
 * @param {...?} slots
 * @return {?}
 */
function sortByStartTime() {
    var slots = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        slots[_i] = arguments[_i];
    }
    return slots.slice().sort((/**
     * @param {?} slotA
     * @param {?} slotB
     * @return {?}
     */
    function (slotA, slotB) {
        return slotA.startDt.isBefore(slotB.startDt) ? -1 : 1;
    }));
}
/**
 * Model representing the arrival time slot of a visit.
 * @record
 */
export function TimeSlot() { }
/**
 * Model representing the arrival time slot of a visit.
 * @type {?}
 */
export var timeSlot = model.extend((/** @type {?} */ ((/** @type {?} */ ({
    modelName: 'timeSlot',
    postConstruct: /**
     * @return {?}
     */
    function () {
        this.day = this.day || todayNaive();
        this.startDt = combine(this.day, this.start);
        this.endDt = combine(this.day, this.end);
    },
    /**
     * Return whether the current slot is equal to the one given.
     * @param other TimeSlot
     * @return boolean
     */
    equals: /**
     * Return whether the current slot is equal to the one given.
     * @param {?} other TimeSlot
     * @return {?} boolean
     */
    function (other) {
        return this.start.isSame(other.start) && this.end.isSame(other.end);
    },
    /**
     * Return whether the current slot's start and end times equal the other,
     * ignoring the day on which they occur.
     * @param other TimeSlot
     * @return boolean
     */
    equalsTime: /**
     * Return whether the current slot's start and end times equal the other,
     * ignoring the day on which they occur.
     * @param {?} other TimeSlot
     * @return {?} boolean
     */
    function (other) {
        var _this = this;
        return ['start', 'end'].every((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return _this[x].isSame(other[x]); }));
    },
    /**
     * Return whether the current slot intersects the other.
     * @param other TimeSlot - The slot to compare with
     * @return boolean
     */
    intersects: /**
     * Return whether the current slot intersects the other.
     * @param {?} other TimeSlot - The slot to compare with
     * @return {?} boolean
     */
    function (other) {
        if (this.isInstant && other.isInstant) {
            // Instants must touch
            return this.startDt.isSame(other.startDt);
        }
        else if (this.isInstant || other.isInstant) {
            // An instant can touch the start of a non-instant, but not the end
            var _a = __read(this.isInstant ? [this, other] : [other, this], 2), instant = _a[0], span = _a[1];
            return !instant.startDt.isBefore(span.startDt) && instant.endDt.isBefore(span.endDt);
        }
        else {
            // Non-instants must actually have a duration intersecting
            var _b = __read(sortByStartTime(this, other), 2), a = _b[0], b = _b[1];
            return a.endDt.isAfter(b.startDt);
        }
    },
    startTimeDisplay: /**
     * @param {?=} __0
     * @return {?}
     */
    function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.replaceWithLabel, replaceWithLabel = _c === void 0 ? false : _c, _d = _b.includeSharp, includeSharp = _d === void 0 ? true : _d, _e = _b.prependWithLabel, prependWithLabel = _e === void 0 ? false : _e;
        if (replaceWithLabel && this.label) {
            return this.label;
        }
        /** @type {?} */
        var start = this.start.format('HH:mm');
        /** @type {?} */
        var end = this.end.format('HH:mm');
        if (prependWithLabel && this.label) {
            return this.label + " " + start + " - " + end;
        }
        if (start === end) {
            return includeSharp ? start + " sharp" : start;
        }
        return start + " - " + end;
    }
})))));
// Implements helper properties declared in TimeSlotModelMixin
defineModelProperties(timeSlot, {
    isInstant: {
        get: /**
         * @return {?}
         */
        function () {
            return this.start.isSame(this.end);
        }
    },
    isAnyTime: {
        get: /**
         * @return {?}
         */
        function () {
            return this.type === SlotType.AnyTime;
        }
    },
    isFlexible: {
        get: /**
         * @return {?}
         */
        function () {
            return this.type !== SlotType.Custom;
        }
    },
    label: {
        get: /**
         * @return {?}
         */
        function () {
            var _this = this;
            /** @type {?} */
            var flexibleSlot = FLEXIBLE_SLOTS.find((/**
             * @param {?} s
             * @return {?}
             */
            function (s) { return s.type === _this.type; }));
            return flexibleSlot ? flexibleSlot.label : null;
        }
    },
    type: {
        get: /**
         * @return {?}
         */
        function () {
            var _this = this;
            /** @type {?} */
            var flexibleSlot = FLEXIBLE_SLOTS.find((/**
             * @param {?} s
             * @return {?}
             */
            function (s) {
                return _this.start.isSame(s.start) && _this.end.isSame(s.end);
            }));
            return flexibleSlot ? flexibleSlot.type : SlotType.Custom;
        }
    }
});
